<template>
    <v-container fluid grid-list-xl>
        <v-layout row wrap>
            <v-flex v-for="(input, i_index) in step.inputs" xs12 md4 :md12="input.type === 'section'" :md8="input.size===2" :key="i_index">
                <s-input :input="input" :inputs="step.inputs"></s-input>
            </v-flex>
            <v-flex xs12>
                <v-btn depressed color="primary" @click.native="$emit('next')">Continuar</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import SInput from "./Input";

    export default {
        props: ['step', 'index'],
        components: {SInput},
        name: "step-content",
        methods: {
            next(){
                this.$emit('next')
            }
        }
    }
</script>

<style scoped>

</style>